import {Login} from './components/login';

export default {
    component: Login
};
